import { curry } from 'utils'

/**
 * curried wrapper around `hasAttribute`
 * @param {String} name attribute name
 * @param {Node} element
 * @return {Function, String, null} found attribute or null
 */
export default curry((name, el) => el.hasAttribute(name))
